export default __webpack_public_path__ + "static/4-faffc26a077112e76eef2c0265674810.webp";